import React from "react";

function NameInput({ setName }) {
  function handleName(e) {
    e.preventDefault();
    setName(e.target.value);
  }
  return (
    <div className="col-lg-6">
      <div className="input-com-group">
        <label className="lable-class">Name</label>
        <input
          placeholder="Enter Name"
          className="input-group"
          type="text"
          minLength="1"
          maxLength="255"
          onChange={handleName}
        />
      </div>
    </div>
  );
}

export default NameInput;
